var _a;
import { __assign } from "tslib";
import { UserType, ItemType, ActivityType } from '../domain';
import { createSimpleCustomFieldsApi } from '../custom-fields';
export * from './dto';
var MAX_PAGE_SIZE = 200;
export var defaultGroupSettings = {
    activitySettings: (_a = {},
        _a[ActivityType.TICKETING] = { scheduleId: undefined, excludedSkills: [] },
        _a)
};
export var createTeamApi = function (baseUrl, http) {
    var agentsPath = "".concat(baseUrl, "/agents");
    var groupsPath = "".concat(baseUrl, "/groups");
    var teamPath = "".concat(baseUrl, "/teams");
    var locationPath = "".concat(baseUrl, "/locations");
    var agentPermissionPath = function (agentId) { return "".concat(agentsPath, "/").concat(agentId, "/permissions"); };
    return {
        getActiveAgents: function (dto) {
            var text = dto.text || '';
            var pageSize = dto.pageSize || MAX_PAGE_SIZE;
            var sortType = dto.sortType ? { agentSortType: dto.sortType } : {};
            return http.post("".concat(agentsPath, "/search"), __assign(__assign(__assign({}, dto), sortType), { pageSize: pageSize, text: text, userTypes: [UserType.AUTHENTICATED] }));
        },
        getPendingAgents: function (dto) {
            var text = dto.text || '';
            var pageSize = dto.pageSize || MAX_PAGE_SIZE;
            var sortType = dto.sortType ? { agentSortType: dto.sortType } : {};
            return http.post("".concat(agentsPath, "/search"), __assign(__assign(__assign({}, dto), sortType), { pageSize: pageSize, text: text, userTypes: [UserType.PENDING] }));
        },
        getAllGroups: function () {
            return http.get(groupsPath);
        },
        getGroupMembers: function (dto) {
            var pageSize = dto.pageSize || MAX_PAGE_SIZE;
            var sortType = dto.sortType ? { agentSortType: dto.sortType } : {};
            return http.post("".concat(agentsPath, "/search"), __assign(__assign({}, sortType), { pageSize: pageSize, groupIds: [dto.groupId] }));
        },
        setAgentPermission: function (dto) {
            return http.put("".concat(agentPermissionPath(dto.agentId)), { permissionLevel: dto.permissionLevel, roleId: dto.roleId });
        },
        removeAgent: function (dto) {
            return http.delete("".concat(agentPermissionPath(dto.agentId)));
        },
        removeAgentFromGroup: function (dto) {
            return http.delete("".concat(groupsPath, "/").concat(dto.groupId, "/members/").concat(dto.agentId));
        },
        addAgentToGroup: function (dto) {
            return http.post("".concat(groupsPath, "/").concat(dto.groupId, "/members"), { userId: dto.agentId });
        },
        editGroupsMembers: function (dto) {
            return http.post("".concat(groupsPath, "/members"), dto);
        },
        addGroup: function (dto) {
            return http.post("".concat(groupsPath), { name: dto.name, settings: defaultGroupSettings });
        },
        editGroup: function (dto) {
            return http.put("".concat(groupsPath, "/").concat(dto.groupId), { name: dto.name, settings: dto.settings });
        },
        deleteGroup: function (dto) {
            return http.delete("".concat(groupsPath, "/").concat(dto.groupId));
        },
        inviteMember: function (dto) {
            return http.post("".concat(agentsPath, "/invite"), dto);
        },
        revokeInvitation: function (dto) {
            return http.post("".concat(agentsPath, "/").concat(dto.agentId, "/revoke-invitation"), {});
        },
        setAgentLocation: function (dto) {
            return http.post("".concat(agentsPath, "/").concat(dto.id, "/data"), { location: dto.location });
        },
        setAgentChannel: function (dto) {
            return http.post("".concat(agentsPath, "/channel"), dto);
        },
        setAgentsChannels: function (dto) {
            return http.post("".concat(agentsPath, "/features"), dto);
        },
        setAgentsChannel: function (dto) {
            return http.post("".concat(agentsPath, "/channels"), dto);
        },
        setAgentsMaxWorkloads: function (dto) {
            return http.post("".concat(agentsPath, "/features/workloads"), dto);
        },
        setAgentStatus: function (dto) {
            return http.post("".concat(agentsPath, "/status"), dto);
        },
        setAgentStatusNew: function (dto) {
            return http.post("".concat(agentsPath, "/status/new"), dto);
        },
        setAgentStatusOnBehalf: function (dto) {
            return http.post("".concat(agentsPath, "/status/new/onBehalf"), dto);
        },
        getCurrentAgent: function () {
            return http.get("".concat(agentsPath, "/me"));
        },
        getAgent: function (agentId) { return http.get("".concat(agentsPath, "/").concat(agentId)); },
        getTeams: function () { return http.get("".concat(teamPath)); },
        getTeam: function (dto) { return http.get("".concat(teamPath, "/").concat(dto.id)); },
        updateTeams: function (dto) { return http.put("".concat(teamPath), dto); },
        getLocations: function () { return http.get("".concat(locationPath)); },
        getLocation: function (dto) { return http.get("".concat(locationPath, "/").concat(dto.id)); },
        updateLocations: function (dto) { return http.put("".concat(locationPath), dto); },
        setAgentDataField: function (dto) { return http.put("".concat(agentsPath, "/").concat(dto.userId, "/").concat(dto.agentDataField), dto); },
        removeAgentDataField: function (dto) {
            return http.delete("".concat(agentsPath, "/").concat(dto.userId, "/").concat(dto.agentDataField));
        },
        updateAgentCustomFields: function (dto) {
            return http.put("".concat(agentsPath, "/").concat(dto.id, "/fields"), dto);
        },
        customFields: createSimpleCustomFieldsApi(agentsPath, http, ItemType.AGENT),
        endAgentSessions: function (id) {
            return http.post("".concat(agentsPath, "/").concat(id, "/handling/end"), {});
        },
        setAgentInterfaceLocale: function (dto) {
            return http.put("".concat(agentsPath, "/me/interfaceLocale"), dto);
        },
        updateGroupManualAvailability: function (dto) {
            return http.put("".concat(groupsPath, "/").concat(dto.id, "/manualAvailability"), dto);
        }
    };
};
//# sourceMappingURL=index.js.map